(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('roi-cart-summary')) {
    customElements.define('roi-cart-summary', class extends HTMLElement {
      connectedCallback() {
        if (!this.handleCartChange) {
          this.handleCartChange = (event) => this.updateTotals(event.detail?.cart);
        }
        document.addEventListener('roi:cart:changed', this.handleCartChange);
      }

      disconnectedCallback() {
        document.removeEventListener('roi:cart:changed', this.handleCartChange);
      }

      updateTotals(cart) {
        if (!cart || !Number.isFinite(cart.total_price) || !Number.isFinite(cart.item_count)) return;
        // 基準額と送料は data 属性。snippets/roi-shipping.liquid 以外に数字を書かない。
        const subtotal = cart.total_price;
        const needsShipping = cart.item_count > 0 && cart.requires_shipping !== false;
        const threshold = Number(this.dataset.freeShippingThreshold);
        const shipping = needsShipping && subtotal < threshold ? Number(this.dataset.shippingFee) : 0;
        const remaining = Math.max(0, threshold - subtotal);
        const formatMoney = (amount) => new Intl.NumberFormat('ja-JP', { maximumFractionDigits: 0 }).format(amount / 100);

        this.querySelectorAll('[data-roi-cart-subtotal]').forEach((element) => {
          element.textContent = formatMoney(subtotal);
        });
        this.querySelector('[data-roi-cart-shipping-row]').hidden = !needsShipping;
        const shippingAmount = this.querySelector('[data-roi-cart-shipping]');
        shippingAmount.textContent = shipping > 0 ? `${formatMoney(shipping)}円` : '無料';
        shippingAmount.classList.toggle('is-free-shipping', needsShipping && shipping === 0);
        this.querySelector('[data-roi-cart-grand-total]').textContent = formatMoney(subtotal + shipping);

        const message = this.querySelector('[data-roi-cart-shipping-message]');
        message.hidden = !needsShipping || remaining === 0;
        message.textContent = remaining > 0 ? `あと${formatMoney(remaining)}円で送料無料！` : '';

        if (subtotal !== Number(this.dataset.initialSubtotal) || cart.item_count !== Number(this.dataset.initialCount)) {
          this.querySelectorAll('[data-roi-cart-compare]').forEach((element) => { element.hidden = true; });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('roi-product-price-actions')) {
    customElements.define('roi-product-price-actions', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.sharing = false;
        const options = { signal: this.controller.signal };
        const favorite = this.querySelector('[data-roi-price-favorite]');
        const original = this.closest('.product')?.querySelector('.product-cta__favorite');
        const share = this.querySelector('[data-roi-price-share]');
        const status = this.querySelector('[data-roi-share-status]');
        const fallback = this.querySelector('[data-roi-share-fallback]');
        const input = fallback.querySelector('input');
        const closeFallback = () => {
          fallback.hidden = true;
          share.setAttribute('aria-expanded', 'false');
        };
        const showStatus = (message) => {
          clearTimeout(this.statusTimer);
          status.textContent = message;
          this.statusTimer = setTimeout(() => { status.textContent = ''; }, 3500);
        };
        if (original) {
          const syncFavorite = () => {
            const active = original.getAttribute('aria-pressed') === 'true';
            favorite.setAttribute('aria-pressed', String(active));
            favorite.setAttribute('aria-label', active ? 'お気に入りから削除' : 'お気に入りに追加');
            favorite.disabled = original.disabled;
          };
          syncFavorite();
          this.favoriteObserver = new MutationObserver(syncFavorite);
          this.favoriteObserver.observe(original, { attributes: true, attributeFilter: ['aria-pressed', 'disabled'] });
          favorite.addEventListener('click', () => { original.click(); syncFavorite(); }, options);
        }
        share.addEventListener('click', async () => {
          if (this.sharing) return;
          if (!fallback.hidden) { closeFallback(); return; }
          this.sharing = true;
          status.textContent = '';
          const data = { title: this.dataset.shareTitle, url: this.dataset.shareUrl };
          try {
            if (typeof navigator.share === 'function') {
              try {
                await navigator.share(data);
                return;
              } catch (error) {
                if (error.name === 'AbortError' || options.signal.aborted) return;
              }
            }
            if (options.signal.aborted) return;
            try {
              await navigator.clipboard.writeText(data.url);
              if (options.signal.aborted) return;
              showStatus('リンクをコピーしました');
            } catch {
              if (options.signal.aborted) return;
              fallback.hidden = false;
              share.setAttribute('aria-expanded', 'true');
              input.focus();
              input.select();
            }
          } finally {
            if (!options.signal.aborted) this.sharing = false;
          }
        }, options);
        this.querySelector('[data-roi-share-close]').addEventListener('click', () => {
          closeFallback();
          share.focus();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !fallback.hidden) {
            closeFallback();
            share.focus();
          }
        }, options);
        this.hidden = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.favoriteObserver?.disconnect();
        clearTimeout(this.statusTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roi-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('roi-related-products')) {
    customElements.define('roi-related-products', class extends HTMLElement {
      connectedCallback() {
        if (this.loadingStarted || !this.dataset.url) return;
        this.loadingStarted = true;
        this.loadRecommendations();
      }

      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
          const list = markup.querySelector('.roi-related-products__list');
          if (!list?.querySelector('.roi-related-products__item') || !this.isConnected) return;
          this.querySelector('.roi-related-products__list').replaceWith(list);
          this.hidden = false;
        } catch {
          this.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
